<p-dialog
  #dialog
  [className]="'eccc'"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '1000px'}"
  [minY]="100"
  [maximizable]="false"
  [autoZIndex]="false"
  [closable]="false"
  [header] = "'COMPLIANCE_REPORT.details.additionalDetailsTitle' | translate"
  (onShow)="scrollToTop()">
  <form [formGroup]="currentStepObj.additionalDetailsForm" *ngIf ="currentStepObj && currentStepObj.additionalDetailsForm">
    <formly-form [form]="currentStepObj.additionalDetailsForm" [model]="currentStepObj.additionalDetailsModel" [fields]="currentStepObj.additionalDetailsFields"></formly-form>
  </form>

  <div *ngIf="currentStepObj.detailSectionDocumentUploadConfig" class="form-group mt-4">
    <app-documents
      [documentUploadConfig]="currentStepObj.detailSectionDocumentUploadConfig"
      (documentResult)="documentUploadHandler($event)"
      [showPlaceholders]="true"
      [disabled]="true">
    </app-documents>
  </div>

  <div class="d-flex justify-content-end mt-2">
    <button type="button" class="btn btn-secondary mr-2" (click)="close()">{{'COMMON.actionsLabel.CLOSE' | translate}}</button>
  </div>
</p-dialog>
